<template>
  <div>
    <TopHeader class="bg-color-wrap" />
    <MainNavbar />
    <PageBanner pageTitle="Services Details" />
    <ServicesDetails />
    <OurProcess />
    <BestPlans />
    <OverView class="pt-100" />
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layout/TopHeader";
import MainNavbar from "../Layout/MainNavbar";
import PageBanner from "../Common/PageBanner";
import ServicesDetails from "../ServicesDetails/ServicesDetails";
import OurProcess from "../ServicesDetails/OurProcess";
import BestPlans from "../Common/BestPlans";
import OverView from "../Common/OverView";
import MainFooter from "../Layout/MainFooter";

export default {
  name: "ServicesDetailsPage",
  components: {
    TopHeader,
    MainNavbar,
    PageBanner,
    ServicesDetails,
    OurProcess,
    BestPlans,
    OverView,
    MainFooter,
  },
};
</script>